import React from 'react';
import {
  EditFormData,
  UrlRule,
  ResponseRule,
  NestedRuleGroup,
  NestedResponseGroup,
} from '../types';
import ConfigurationRuleEdit from './ConfigurationRuleEdit';

interface NewConfigurationFormProps {
  formData: EditFormData;
  onFormDataChange: (data: EditFormData) => void;
  onAddUrlRule: (groupId?: string) => void;
  onUpdateUrlRule: (groupId: string, ruleId: string, field: keyof UrlRule, value: any) => void;
  onRemoveUrlRule: (groupId: string, ruleId: string) => void;
  onAddUrlGroup: (parentGroupId?: string) => void;
  onUpdateUrlGroup: (groupId: string, updates: Partial<NestedRuleGroup>) => void;
  onRemoveUrlGroup: (groupId: string) => void;
  onAddResponseRule: (groupId?: string) => void;
  onUpdateResponseRule: (
    groupId: string,
    ruleId: string,
    field: keyof ResponseRule,
    value: any,
  ) => void;
  onRemoveResponseRule: (groupId: string, ruleId: string) => void;
  onAddResponseGroup: (parentGroupId?: string) => void;
  onUpdateResponseGroup: (groupId: string, updates: Partial<NestedResponseGroup>) => void;
  onRemoveResponseGroup: (groupId: string) => void;
}

const NewConfigurationForm: React.FC<NewConfigurationFormProps> = (props) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <ConfigurationRuleEdit {...props} isNewConfiguration={true} />
    </div>
  );
};

export default NewConfigurationForm;
